import { ErrorMessages } from '@csp/csp-common-form';
import { useLoading as useLoadingHook, UseLoadingReturnType } from '@csp/fe-hooks';
import { ErrorService } from '@csp/web-common';
import { useGetErrorMessage } from './useGetErrorMessage';

export const useLoading = <T = undefined>(
  isLoadingInitial?: boolean,
  additionalErrorMessages?: ErrorMessages,
): UseLoadingReturnType<T> => {
  const getErrorMessage = useGetErrorMessage(additionalErrorMessages);
  return useLoadingHook({
    getErrorMessage,
    errorHandler: ErrorService.handleError,
    clearErrorOnSetLoading: true,
    isLoadingInitial,
  });
};
